import { z } from 'zod';

export const aiSummaryOutputFormatValidator = z
  .enum(['one-liner', 'bullet-point', 'paragraph'])
  .default('paragraph');

export type AiSummaryOutputFormat = z.infer<typeof aiSummaryOutputFormatValidator>;

export const aiSummaryFieldConfigValidator = z.object({
  outputFormat: aiSummaryOutputFormatValidator
});

export type AiSummaryFieldConfig = z.infer<typeof aiSummaryFieldConfigValidator>;

export const aiFieldConfigValidator = z.discriminatedUnion('aiFieldType', [
  z
    .object({
      aiFieldType: z.literal('summary'),
      field: aiSummaryFieldConfigValidator.default({})
    })
    .strict()
]);

export type AiFieldConfig = z.infer<typeof aiFieldConfigValidator>;
